import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
		
		
		
		
    getRankLName(data) {
        return axios.request({
            url: "arrange/grouplist",
            method: "get",
            params: data,
        });
    },
    getRankList(data) {
        return axios.request({
            url: "arrange/groupdetail",
            method: "get",
            params: data,
        });
    },
		getRankList2(data) {
		    return axios.request({
		        url: "arrange/scoredetail",
		        method: "get",
		        params: data,
		    });
		},
		editScore(data) {
		    return axios.request({
		        url: "arrange/editscore",
		        method: "get",
		        params: data,
		    });
		},
		
		
		getDataBoard(data){
			return axios.request({
			    url: "arrange/get-arrange",
			    method: "get",
			    params: data,
			});
		},
		getPersonsData(data){
			return axios.request({
			    url: "arrange/arrange-list",
			    method: "get",
			    params: data,
			});
		},
		
		editscore(data){
			return axios.request({
			    url: "arrange/arrange-edit",
			    method: "post",
			    data,
			});
		},
		
		getTrackid(data){
			return axios.request({
			    url: "match/tracklist",
			    method: "get",
			    params: data,
			});
		},
		getAllPerson(data){
			return axios.request({
			    url: "arrange/enroll-group-list",
			    method: "get",
			    params: data,
			});
		},
		getAllPersonData(data){
			return axios.request({
			    url: "arrange/enroll-group-list-manual",
			    method: "get",
			    params: data,
			});
		},
		submitPerson(data){
			return axios.request({
			    url: "arrange/submit-enroll-group",
			    method: "post",
			    data,
			});
		},
		submitPersonData(data){
			return axios.request({
			    url: "arrange/submit-enroll-group-manual",
			    method: "get",
			    params: data,
			});
		},
		
		
}